// Company context line sent with Gap Analysis AI scoring requests. Never a stand-in name:
// when the company name is missing the AI call is blocked (the caller shows `reason`).
export function buildGapAiCompanyContext(project) {
  const name = typeof project?.companyName === 'string' ? project.companyName.trim() : '';
  if (!name) {
    return {
      ok: false,
      companyContext: '',
      reason: 'Add the company name to the project before generating AI scores.',
    };
  }
  const companyContext = [
    `Company: ${name}`,
    project?.certification ? `Framework: ${project.certification}` : null,
    project?.profile?.companyProfile?.gicsIndustry ? `Industry: ${project.profile.companyProfile.gicsIndustry}` : null,
  ]
    .filter(Boolean)
    .join(', ');
  return { ok: true, companyContext, reason: null };
}
